import "./NoResultQuiz.css";

const NoResultQuiz = () => {
  return (
    <div
      className="no-result-container-quiz"
      style={{ border: "1px solid #e0e2e5" }}
    >
      Ainda não há um histórico de perguntas.
    </div>
  );
};

export default NoResultQuiz;
